import { usePodcastProvider, PodcastConfig, ModalType } from "./PodcastProvider";
import { formatUnixTimestamp, secondsToHms } from "services/utils";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { Flex, Text, Image } from "@chakra-ui/react";
import { PodcastModal } from "./Modals";
import PodcastColorTypes from "types/podcastColorTypes";
import { CustomPlayPause } from "components/podcast/CustomMediaPlayer";

interface PodcastEpisodeTileProps {
  data: PodcastConfig;
}

export function PodcastEpisodeTile({ data }: PodcastEpisodeTileProps) {
  const { isOpen, onOpen, setPlayingPodcast, setModalType, setPlayPodcast, playingPodcast } = usePodcastProvider();
  const showComponents = isOpen ? "none" : "flex";

  const descriptionSubstring = data?.description.substring(0, 100);
  const publishDate = data.created ? formatUnixTimestamp(data.created) : " ";
  const podcastLength = data.length ? secondsToHms(data?.length) : 0;

  const openModal = () => {
    if (data?.episode_number !== playingPodcast?.episode_number) {
      setPlayingPodcast(data);
    }
    setModalType(ModalType.Details);
    onOpen();
    setPlayPodcast(true);
  };

  return (
    <Flex position="relative" fontFamily="sora" flexDir="column" borderRadius="12px" display={{ base: showComponents, md: "flex" }} onClick={openModal} cursor="pointer">
      <Image src={data.thumbnail_url} position="absolute" width="100%" height="100%" borderRadius="12px" alt="Episode Image" />
      <Flex zIndex="10" p="16px" fontSize="12px" width="100%" lineHeight="16px" letterSpacing="2px" color="purple.50" justifyContent="space-between">
        <Flex height="24px" px="8px" py="4px" bg={getPodcastThemeToken(PodcastColorTypes.IconsBackground)} color={getPodcastThemeToken(PodcastColorTypes.Icons)} borderRadius="8px">
          #{data.episode_number}
        </Flex>
        {data?.audio_urls && <PodcastModal modalButtonType={ModalType.Details} podcastDetails={data} />}
        {data.video_urls && <CustomPlayPause handlePlayPodcast={openModal} podcastDetails={data} />}
      </Flex>
      <Flex position="relative" mt="92px" fontSize="14px" width="100%" lineHeight="24px" color="purple.50">
        <Flex zIndex="10" px="16px" pb="12px" flexDir="column">
          <Flex px="12px" py="8px" borderRadius="8px" bg={getPodcastThemeToken(PodcastColorTypes.EpisodeTitleContainerBackground)} maxWidth="240px" width="100%" fontWeight="600">
            <Text as="h5">{data.title}</Text>
          </Flex>
          <Flex fontSize="12px" lineHeight="18px" mt="7px">
            <Text color={getPodcastThemeToken(PodcastColorTypes.EpisodeTimeText)}>{publishDate}</Text>
            <Text ml="32px" color={getPodcastThemeToken(PodcastColorTypes.EpisodeTimeText)}>
              {podcastLength}
            </Text>
          </Flex>
          <Flex fontSize="12px" width="100%" lineHeight="16px" color={getPodcastThemeToken(PodcastColorTypes.EpisodeText)} mt="4px">
            {descriptionSubstring}...
          </Flex>
          {(data?.audio_urls || data.video_urls) && (
            <Flex zIndex="10" mt="8px">
              {data?.audio_urls && <PodcastModal modalButtonType={ModalType.Download} podcastDetails={data} />}
              <PodcastModal modalButtonType={ModalType.Share} podcastDetails={data} />
            </Flex>
          )}
        </Flex>
        <Flex bg={getPodcastThemeToken(PodcastColorTypes.EpisodeContainerBackground)} width="100%" height="calc(100% - 19px)" top="19px" position="absolute" zIndex="5" borderRadius="12px"></Flex>
      </Flex>
    </Flex>
  );
}
